

export const SUCCESSMESSAGE = {
    variant: 'success',
    autoHideDuration: 4000,
    preventDuplicate: true,
}

export const INFOMESSAGE = {
    variant: 'info',
    //persist: true,
    autoHideDuration: 3000,
    preventDuplicate: true,
    //persist: true,

}

export const LOADMESSAGE = {
    variant: 'info',
    persist: true,
    //autoHideDuration: 3000,
    preventDuplicate: true,
    //persist: true,

}


export const INFOALMOCOMESSAGE = {
    variant: 'info',
    //preventDuplicate: true,
    persist: true,
    //autoHideDuration: 7000,
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
    }
}



export const ERRORMESSAGE = {
    variant: 'error',
    autoHideDuration: 5000,
    preventDuplicate: true,

}


export const WARNINGMESSAGE = {
    variant: 'warning',
    autoHideDuration: 5000,
    preventDuplicate: true,

}







